
<template>
    <v-dialog v-model="open" max-width="80%" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
        persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card"> 
                <span class="white--text headline" v-html="obModal.titulo"></span>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="$root.isTouch" rounded outlined @click="close(false)">
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Póliza" color="textbox" readonly :value="obModal.poliza" outlined dense/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Aseguradora" color="textbox" readonly :value="obModal.aseguradora" outlined dense/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Contratante" color="textbox" readonly :value="obModal.contratante" outlined dense/>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Fecha Inicio" color="textbox" readonly :value="obModal.fechaDesde" outlined dense/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Fecha Fin" color="textbox" readonly :value="obModal.fechaHasta" outlined dense/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-dialog ref="dialog" v-model="openDate" :return-value.sync="obModal.fechaOcurrencia"
                                    persistent width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field color="textbox" v-model="obModal.fechaOcurrencia"
                                            label="Fecha Ocurrencia *" :rules="requeridoRegla" prepend-inner-icon="event" readonly
                                            outlined dense v-on="on" />
                                    </template>
                                    <v-date-picker color="primary" v-model="obModal.fechaOcurrencia" scrollable locale="es">
                                        <v-spacer></v-spacer>
                                        <v-btn outlined dense rounded @click="openDate = false" v-html="'Salir'"></v-btn>
                                        <v-btn rounded dark color="primary"
                                            @click="$refs.dialog.save(obModal.fechaOcurrencia)" v-html="'Guardar Fecha'">
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Asegurado" color="textbox" readonly :value="obModal.asegurado" outlined dense/>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Tipo Siniestro *" color="textbox" v-model="obModal.idTipoSiniestro"
                                        :items="listGeneral.listTipoSiniestro" item-text="tipoSiniestro"
                                        item-value="idSecTipoSiniestro" :rules="requeridoRegla" outlined dense />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Valor Reserva" color="textbox" v-model="obModal.valorReserva" outlined dense 
                                              :rules="_.concat(requeridoRegla,decimal)"/>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Taller *" color="textbox" v-model="obModal.idTaller"
                                        :items="listGeneral.listTalleres" item-text="nombre"
                                        item-value="idTaller" :rules="requeridoRegla" outlined dense />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12">
                                 <v-textarea label="Siniestro *" color="textbox" no-resize v-model="obModal.explicacionSiniestro"
                                        :value="obModal.explicacionSiniestro" :rules="requeridoRegla" counter="1000" outlined dense />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-list two-line subheader dense>
                                    <v-subheader inset>Documentos</v-subheader>

                                    <v-list-item
                                        v-for="item in listFile"
                                        :key="item.title"
                                        dense
                                        @click="openInputFile(item)"
                                    >
                                        <v-list-item-avatar>
                                        <v-icon
                                            :class="[item.iconClass]"
                                            v-text="item.icon"
                                        ></v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.title"></v-list-item-title>
                                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                                            <input type="file" :name="item.id" :id="item.id" @change="loadFile" style="display:none">
                                        </v-list-item-content>

                                        <v-list-item-action>
                                        <v-btn icon>
                                            <v-icon color="primary">cloud_upload</v-icon>
                                        </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>

                        <v-row dense v-if="!isMovil">
                            <v-col cols="12" sm="6" class="text-left">
                                <v-btn rounded dark color="primary" class="mr-1" @click="validar(false)" :disabled="disabled">Cerrar Siniestro</v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" class="text-right">
                                <v-btn outlined dense rounded class="mr-1" @click="close(false)">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" class="mr-1" @click="validar(false)" :disabled="disabled">Guardar</v-btn>
                                <v-btn rounded dark color="secondary" @click="validar(true)" :disabled="disabled">Reportar Siniestro</v-btn>
                            </v-col>
                        </v-row>

                        <v-row dense v-else>
                            <v-col cols="12" sm="12">
                                <v-btn block rounded dark color="primary" @click="validar(false)" :disabled="disabled">Cerrar Siniestro</v-btn>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-btn block outlined dense rounded @click="close(false)">Cancelar</v-btn>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-btn block rounded dark color="primary" @click="validar(false)" :disabled="disabled">Guardar</v-btn>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-btn block rounded dark color="secondary" @click="validar(true)" :disabled="disabled">Reportar Siniestro</v-btn>
                            </v-col>
                        </v-row>

                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalAperturaSiniestroComponent',
        inject:['close'],
        props:{
            open:{
                type:Boolean,
                default:false
            },
            listGeneral:{
                type:Object,
                default:{}
            },
            obModal:{
                type:Object,
                default:{}
            },
            parametros:{
                ttype:Object,
                default:{}
            }
        },
        data: () => ({
            openDate:false,
            listFile:{},
            disabled:false
        }),
        watch:{
            open(val){
                if(val){
                    this.disabled = false;
                    var l = _.cloneDeep(_.get(this.listGeneral,'listDocumentos',[]));

                    _.map(l,(v)=>{
                        var id = _.camelCase(v.documento);
                        v.iconClass = 'blue white--text';
                        v.icon = 'assignment';
                        v.title = v.documento;
                        v.subtitle = '';
                        v.base = '',
                        v.id = _.camelCase(v.documento);

                        this.$set(this.listFile,id,v);
                        return v;
                    });

                    this.onListarTallerXAseguradora('L');
                }
            }
        },
        methods:{
            onListarTallerXAseguradora(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var o = {
                        opcion:'LISTAR_TALLER_X_ASEGURADORA',
                        idAseguradora:this.obModal.idAseguradora
                    }
                    axios.post(`${BASE_URI}administrador/aseguradora/listar`,o)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                this.$set(this.listGeneral,'listTalleres',r.data.data);
                         })
                         .catch((e)=>{
                            mensajesAlerta(e,error);
                         });
                }
            },
            openInputFile(v){
                var f = document.getElementById(v.id);
                f.click();
            },
            loadFile(e){
                try {
                    var obj = e.target;
                    if(obj.files.length == 0) throw mensajeEstandar.faltaArchivos;
                    if(obj.files[0].size > this.parametros.taMaxArchivo) throw mensajeEstandar.taMaximoArchivoPdf;

                        return new Promise((resolve,reject)=>{
                            var fr = new FileReader();

                            fr.readAsDataURL(obj.files[0]);
                            fr.addEventListener('load', () => {
                                this.listFile[obj.id].base = fr.result;
                                this.$forceUpdate();
                            });

                            return resolve(true);
                        })
                        .then((r)=>{
                            if(!r) throw mensajeEstandar.taMaximoArchivoPdf;
                                this.listFile[obj.id].subtitle  = obj.files[0].name;
                                this.listFile[obj.id].iconClass = 'indigo lighten-2 white--text';   
                                this.totalFiles += !this.listFile[obj.id].band ? 1 : 0;
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,'I');
                        });
                } catch (error) {
                    this.listFile[obj.id].subtitle  = '';
                    this.listFile[obj.id].iconClass = 'grey lighten-1 white--text';
                    mensajesAlerta(mensajeEstandar.taMaximoArchivoPdf,'I');
                }
            },
            validar(band=false){
                try {
                    var error = 'E';
                    this.disabled = true;
                    var l = _.filter(_.cloneDeep(this.listFile),(v)=>{ return _.size(v.base) > 0; });
                    var nro = _.split(this.obModal.polCer,'-');
                    var o = {
                        obSiniestro:{
                            idSiniestro:this.obModal.idSiniestro,
                            idCertificado:this.obModal.idCertificado,
                            idPoliza:this.obModal.idPoliza,
                            fechaOcurrencia:this.obModal.fechaOcurrencia,
                            fechaInicioApertura:_.size(this.obModal.fechaInicioApertura) > 0 ? this.obModal.fechaInicioApertura : moment().format('YYYY-MM-DD h:mm:ss'),
                            idTipoSiniestro:this.obModal.idTipoSiniestro,
                            valorReserva:this.obModal.valorReserva,
                            idEstadoSiniestro:this.obModal.idEstadoSiniestro,
                            poliza:_.join(nro,'_'),
                            idEstado:this.obModal.idEstado
                        },
                        obDetalleSiniestro:{
                            idSecSiniestroDetalle:this.obModal.idSecSiniestroDetalle,
                            idTaller:this.obModal.idTaller,
                            idEstadoDetalle:this.parametros.idEstadoDefault
                        },
                        listPreguntaNotificacion:[{
                            idSecSiniestroPregunta:this.obModal.idSecSiniestroPregunta,
                            idSiniestro:this.obModal.idSiniestro,
                            idPregunta:this.obModal.idPregunta,
                            respuesta:this.obModal.explicacionSiniestro,
                            idEstado:this.parametros.idEstadoDefault
                        }],
                        listDocumentos:_.values(_.map(l,_.partialRight(_.pick,['idDocumento','base','nombreArchivo'])))
                    };

                    if(band){
                        if(!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                            o.obSiniestro.fechaCierreApertura = moment().format('YYYY-MM-DD h:mm:ss');  
                            o.obSiniestro.idEstadoSiniestro = this.parametros.idEstadoSiniestroAnalizandoCaso;  
                    }
                    
                    o = _.merge({},o,{opcion:'UNA',enviarEmail:band});
                    

                    axios.post(`${BASE_URI}administrador/siniestro/insertOrUpdate/apertura`,o)
                            .then((r)=>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                    mensajeAlertaTiempo('Registro actualizado con exito.','S');
                                    this.close(true);
                            })
                            .catch((e)=>{
                                mensajesAlerta(e,error);
                                this.disabled = false;
                            });

                } catch (error) {
                    mensajesAlerta(error,'I');
                    this.disabled = false;
                }
            }
        }
    }
</script>